import { baseUrl } from '../../../baseurl';
import { create } from 'zustand';
import axios from 'axios';
import Loader from '../../../components/Loader/Loader';


export const useUserInfo = create((set, get) => ({
    userInfo: [],
    userInfoWithMobile: [],
    loader: false,
    isSuccessEdit: false,
    bookmasrList: [],
    isFollow: false,
    isLoginUser: false,
    isBusinessUserCheck: "",
    followersList: [],
    followingList: [],
    isUsersFollower: false,
    isSuccessBlock: false,
    blockeListUsers: [],
    isUserBlocked: false,
    isSearch: false,
    isCatch: false,
    showServerError: false,
    isDeleteProfile: false,
    businessAccountNameCheck: null,

    actions: {

        getBusinessAccountNameCheck: async (businessAccountName) => {
            await axios.post(`${baseUrl}/User/GetBusinessAccountNameCheck`, {
                "businessAccountName": businessAccountName,
            })
                .then((res) => {
                    set((state) => ({ businessAccountNameCheck: res.data }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        deleteUserProfileImage: async (userId) => {
            let body = {
                "userId": userId
            }
            await axios.delete(`${baseUrl}/User/DeleteUserProfileImage`,
                {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                    data: body
                },)
                .then((res) => {
                    set((state) => ({ userInfo: res.data }))
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterBookmarkByUserIdSearch: async (usrUserCode, searchQuery) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterBookmarkByUserId?UsrUserCode=${usrUserCode}&SearchQuery=${searchQuery}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ bookmasrList: res.data }))
                    set((state) => ({ loader: false }))
                    set((state) => ({ isSearch: true }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getUserInfoWithMobile: async (mobileNumber) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/User/GetAllUser?MobilNumber=${mobileNumber}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ userInfoWithMobile: res.data }))
                    set((state) => ({ loader: false }))
                })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getUserInfo: async (useId) => {


            const isNumeric = /^\d+$/.test(useId);
    
            if (isNumeric) {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrl}/User/GetAllUser?Id=${useId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                    .then((res) => {
                        set((state) => ({ userInfo: res.data.result }))
                        set((state) => ({ loader: false }))

                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else if (!isNumeric) {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrl}/User/GetBusinessUserByBusinessAccountName?BusinessAccountName=${useId}`)
                    .then((res) => {
                        set((state) => ({ userInfo: res.data }))
                        set((state) => ({ loader: false }))

                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }



        },
        checkIsUserLogin: async (MobileNumber) => {
            await axios.get(`${baseUrl}/User/GetAllUser?MobileNumber=${MobileNumber}`)
                .then((res) => {
                    if (res.data.length) {
                        set((state) => ({ isLoginUser: true }))
                    } else {
                        set((state) => ({ isLoginUser: false }))
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        editUser: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        localStorage.setItem("pelakAuthData", res.data.id)
                        // Show success message
                        
                        set((state) => ({ haveLike: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ isSuccessEdit: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessEdit: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
        editUserWitoutToken: async (
            id, lastUserId, firstName, lastName, businessExpertise,
            businessAccountName, adsMainCategoryCode,
            nationalCode, email, gender,
            mobileNumber, phoneNumber, emergencyNumber,
            birthDate, country, state, city, longitudes, latitudes,
            address, isBusinessUser, description, perssonelPicUrl,
            businessLicensePicUrl, shPicUrl, otherDocumnetUrl, nationalCardPicUrl, positionCode,
            businessLicenseNumber, instagramId, telegramId, userTypeCode, userRegisterStatusCode,
            isUpdated, isShowPhoneNumber, isChatEnable
        ) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/User/EditUser`, {
                "id": id,
                "lastUserId": lastUserId,
                "firstName": firstName,
                "lastName": lastName,
                "businessExpertise": businessExpertise,
                "businessAccountName": businessAccountName,
                "adsMainCategoryCode": adsMainCategoryCode,
                "nationalCode": nationalCode,
                "email": email,
                "gender": gender,
                "mobileNumber": mobileNumber,
                "phoneNumber": phoneNumber,
                "emergencyNumber": emergencyNumber,
                "birthDate": birthDate,
                "country": country,
                "state": state,
                "city": city,
                "longitudes": longitudes,
                "latitudes": latitudes,
                "address": address,
                "isBusinessUser": isBusinessUser,
                "description": description,
                "perssonelPicUrl": perssonelPicUrl,
                // "profilePicUrl": profilePicUrl,
                "businessLicensePicUrl": businessLicensePicUrl,
                "shPicUrl": shPicUrl,
                "otherDocumnetUrl": otherDocumnetUrl,
                "nationalCardPicUrl": nationalCardPicUrl,
                "positionCode": positionCode,
                "businessLicenseNumber": businessLicenseNumber,
                "instagramId": instagramId,
                "telegramId": telegramId,
                "userTypeCode": userTypeCode,
                "userRegisterStatusCode": userRegisterStatusCode,
                "isUpdated": isUpdated,
                "isShowPhoneNumber": isShowPhoneNumber,
                "isChatEnable": isChatEnable
            })
                .then((res) => {
                    if (res.status == 200) {
                        localStorage.setItem("pelakAuthData", res.data.id)
                        set((state) => ({ haveLike: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ isSuccessEdit: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessEdit: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        saveUserProfilelImage: async (userId, file) => {
            await axios.post(`${baseUrl}/User/SaveUserProfileImage?UserId=${userId}`, {
                "userId": userId,
                "file": file
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                    "Content-Type": "multipart/form-data",
                    "x-rapidapi-host": "file-upload8.p.rapidapi.com",
                    "x-rapidapi-key": "your-rapidapi-key-here",
                },
            })
                .then((res) => {
                    get().actions.getUserInfo(localStorage.getItem("pelakAuthData"));
                })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        getAdsMasterBookmarkByUserId: async (
            useId,
            adsPrptyTypeCode,
            adsPrptyTradeTypeCode,
            areaCode,
            priceFrom,
            priceTo,
            depositFrom,
            depositTo,
            rentFrom,
            rentTo,
            meterageFrom,
            meterageTo,
            buldingLifeFrom,
            buldingLifeTo,
            adsDateTimeFrom,
            adsDateTimeTo,
            parking,
            basement,
            elevator


        ) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/Advertise/GetAdsMasterBookmarkByUserId `, {
                "useId": useId,
                "AdsPrptyTypeCode": adsPrptyTypeCode,
                "AdsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "AreaCode": areaCode,
                "PriceFrom": priceFrom,
                "PriceTo": priceTo,
                "DepositFrom": depositFrom,
                "DepositTo": depositTo,
                "RentFrom": rentFrom,
                "RentTo": rentTo,
                "MeterageFrom": meterageFrom,
                "MeterageTo": meterageTo,
                "BuldingLifeFrom": buldingLifeFrom,
                "BuldingLifeTo": buldingLifeTo,
                "AdsDateTimeFrom": adsDateTimeFrom,
                "AdsDateTimeTo": adsDateTimeTo,
                "Parking": parking,
                "Basement": basement,
                "Elevator": elevator,

            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ bookmasrList: res.data }))
                    set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        editAdsMasterBookmarkPin: async (usrUserCode, adsMasterCode) => {
            await axios.patch(`${baseUrl}/Advertise/EditAdsMasterBookmarkPin`, {
                "usrUserCode": usrUserCode,
                "adsMasterCode": adsMasterCode
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsUserFollow: async (userId, adsMasterUserId) => {
            await axios.post(`${baseUrl}/User/GetAdsUserFollow`, {
                "userId": userId,
                "adsMasterUserId": adsMasterUserId
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ isFollow: true }))
                    } else (
                        set((state) => ({ isFollow: false }))
                    )
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getIsBusinessUser: async (userId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/User/GetIsBusinessUser?UserId=${userId}`)
                .then((res) => {
                    set((state) => ({ isBusinessUserCheck: res.data }))
                    set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getUserFollowersList: async (userId, searchQuery) => {
            if (searchQuery) {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrl}/User/GetUserFollowersList`, {
                    "userId": userId,
                    "searchQuery": searchQuery
                })
                    .then((res) => {
                        set((state) => ({ isSearch: true }))
                        set((state) => ({ isUsersFollower: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followersList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrl}/User/GetUserFollowersList`, {
                    "userId": userId,
                })
                    .then((res) => {
                        set((state) => ({ isUsersFollower: true }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followersList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }

        },

        getUserFollowingList: async (userId, searchQuery) => {
            if (searchQuery) {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrl}/User/GetUserFollowingList`, {
                    "userId": userId,
                    "searchQuery": searchQuery
                })
                    .then((res) => {
                        set((state) => ({ isSearch: true }))
                        set((state) => ({ isUsersFollower: false }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followingList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.post(`${baseUrl}/User/GetUserFollowingList`, {
                    "userId": userId,
                })
                    .then((res) => {
                        set((state) => ({ isUsersFollower: false }))
                        set((state) => ({ loader: false }))
                        set((state) => ({ followingList: res.data }))
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }

        },

        userBlockToggle: async (blockerUserId, userToBeBlockedId) => {
            await axios.post(`${baseUrl}/User/UserBlockToggle`, {
                "blockerUserId": Number(userToBeBlockedId),
                "userToBeBlockedId": Number(blockerUserId),

            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        set((state) => ({ isSuccessBlock: true }))
                        setTimeout(() => {
                            set((state) => ({ isSuccessBlock: false }))
                        }, 2000);
                    }
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },


        getUserBlockList: async (userId, searchQuery) => {
            set((state) => ({ loader: true }))
            if (searchQuery) {
                await axios.get(`${baseUrl}/User/GetUserBlockList?UserId=${userId}&SearchQuery=${searchQuery}`, {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        if (res.status == 200) {
                            set((state) => ({ loader: false }))
                            set((state) => ({ blockeListUsers: res.data }))
                        }
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                await axios.get(`${baseUrl}/User/GetUserBlockList?UserId=${userId}`, {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        if (res.status == 200) {
                            set((state) => ({ loader: false }))
                            set((state) => ({ blockeListUsers: res.data }))
                        }
                    }).catch(() => {
                        set((state) => ({ isCatch: true }))
                        set((state) => ({ showServerError: true }))
                    })
            }
        },

        getIsUserBlocked: async (userId, token) => {
            // set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/User/GetIsUserBlocked?UsertId=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then(async (res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ isUserBlocked: true }))
                    } else {
                        set((state) => ({ isUserBlocked: false }))
                    }
                    // set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ isCatch: true }))
                    set((state) => ({ showServerError: true }))
                })
        },
    }
}))